import Vue from 'vue';
import VueI18n from 'vue-i18n';

import is from '@/translations/is.json';
import en from '@/translations/en.json';

Vue.use(VueI18n);

const locales = {is, en};
const availableLocales = Object.keys(locales);
const initialLocale = 'is';

const i18n = new VueI18n({
	locale: initialLocale,
	fallbackLocale: initialLocale,
	messages: locales,
	silentTranslationWarn: process.env.NODE_ENV !== 'development'
});

export {
	locales,
	availableLocales,
	initialLocale
};

export default i18n;
